import React from 'react'

export default function Marketing() {
  return (
    <svg width="120" height="80" viewBox="0 0 120 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="14" y1="70" x2="14" y2="28" stroke="black" stroke-width="4" className='path'/>
    <line x1="38" y1="70" x2="38" y2="18" stroke="black" stroke-width="4" className='path'/>
    <line x1="50" y1="70" x2="50" y2="24" stroke="black" stroke-width="4" className='path'/>
    <line x1="26" y1="70" x2="26" y2="31" stroke="black" stroke-width="4" className='path'/>
    <rect x="2" y="2" width="116" height="76" rx="8" stroke="black" stroke-width="4" />
    <path  d="M64.4382 68.7507L73.5 64.5L75.5 58L81.5 60L85 52L93.5 46.5L103.5 35.5L108.438 13.7507" stroke="black" stroke-width="4" className='path1'/>
    </svg>
    
  )
}
